module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI4ODJmN2Y3NTIyYmRjMTU2MWQ1MjA2MmZjYzFiNDVlZC5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon.svg
// module id = 1365
// module chunks = 0